import { css } from "styled-components";

export const multipleSendTagStyle = css`
  .multipleSendTagButton {
    border: 1px solid #ddd;
    min-width: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    cursor: pointer;
    margin: 0 auto;
    text-align: center;
    vertical-align: bottom;
    background-color: #3075f6;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 0px 6px 0px #0000001A;

    font-size: 12px;
    color: #ececec;
    padding: 4px;
  }

  .multipleSendTagButton::before {
    content: "@";
    color: white;
  }

  .multipleSendTagButton:focus::before {
    content: "";
  }
`
